var map = {
	"./rollei1.jpg": 7367,
	"./rollei2.jpg": 9601,
	"./rollei3.jpg": 9876,
	"./rollei4.jpg": 8625,
	"./rollei5.jpg": 9581,
	"./rollei6.jpg": 5920,
	"./rollei7.jpg": 1636,
	"./rollei8.jpg": 6977,
	"./rollei9.jpg": 1903,
	"./rolleia10.jpg": 2741,
	"./rolleib11.jpg": 4086,
	"./rolleic12.jpg": 3847,
	"./rolleid13.jpg": 1395,
	"./rolleie14.jpg": 5742,
	"./rolleif15.jpg": 889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4490;